module.exports = __webpack_public_path__ + "static/media/menu-settings.27c09d11.svg";